<template>
  <div>
    <div class="col-lg-12 text-center mt-5 mb-2">
      <span><h2><b>Inventario por {{nameMarca}} XD</b></h2></span>
    </div>
    <div class="row justify-content-end mb-4 mt-4">
            <jsonExcel :data="forExcel"
              class="btn btn-secondary"
              :fields= "{
                'Codigo de Barras': 'barcode',
                'Producto': 'product',
                'Cantidad': 'amount',
                'Catalogo': 'catalogo',
                'Proveedor': 'provider'
              }"
              worksheet="Reporte Inventario"
              name="Reporte de Inventario.xls"
            >
              Descargar a Excel
            </jsonExcel>
    </div>
    <template>
      <div v-for="provider in jsondata" :key="provider.id_provider" class="mt-5">
        <h3><span style="color:red"><b>{{provider.provider}}</b></span></h3>
        <vue-good-table
          mode="remote"
          :columns="columns"
          :rows="provider.items"
          :totalRows="totalRecords"
          :sort-options="{
              enabled: true,
              initialSortBy: [{field: 'name', type: 'asc'}]
            }"
          styleClass="vgt-table bordered"
          :pagination-options="{
              enabled: true,
              mode: 'registros',
              position: 'top',
              perPage: 10,
              nextLabel: 'siguiente',
              prevLabel: 'anterior',
              rowsPerPageLabel: 'Filas por página',
              ofLabel: 'de',
              pageLabel: 'páginas', // for 'pages' mode
              allLabel: 'Todos',
            }"
          @on-page-change="onPageChange"
          @on-sort-change="onSortChange"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange">
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'config'" @click="ShowDetail(props.row)" class="btn btn-primary">
                  Detalle
              </span>
            </template>
          </vue-good-table>
      </div>
    </template>
    <modal name="DetalleInventario" :adaptive="true" :scrollable="true" height="550" class="">
      <div class="text-right">
        <span class="close-modal" @click="$modal.hide('DetalleInventario')">
          <font-awesome-icon :icon="['fa', 'times-circle']" />
        </span>
      </div>
      <div class="text-center reset-pass">
        <h2>Detalle de inventario </h2>
        <h5>{{detailStocktaking[0].product}}</h5>
        <div class="mt-3 col-lg-12">
          <b-table
            show-empty
            stacked="md"
            :fixed="true"
            :borderless="true"
            :items="itemsInventarioDetail"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            class="table"
          >
          </b-table>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { BTable } from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'
import moment from 'moment'
import { mapGetters } from 'vuex'
import JsonExcel from 'vue-json-excel'

moment.locale('es')
// const axios = require('axios')
// var https = require('https')

export default {
  props: ['marca'],
  mixins: [formatData],
  components: {
    VueGoodTable,
    BTable,
    JsonExcel
  },
  data () {
    return {
      forExcel: [],
      nameMarca: '',
      rows: [],
      itemsInventarioDetail: [],
      isLoading: false,
      id_provider: 0,
      jsondata: [],
      detailStocktaking: [{
        client: '',
        statusName: '',
        cantidad: '',
        date: '',
        id_client: 0
      }],
      optionsMarca: [],
      optionsEnterprise: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'Codigo Producto',
          field: 'barcode',
          filterOptions: {
            placeholder: 'Codigo de barras',
            enabled: true
          }
        },
        {
          label: 'Producto',
          field: 'product',
          filterOptions: {
            placeholder: 'Producto',
            enabled: true
          }
        },
        {
          label: 'Cantidad',
          field: 'amount',
          filterOptions: {
            placeholder: 'Cantidad',
            enabled: true
          }
        },
        {
          label: 'Catalogo',
          field: 'catalogo',
          filterOptions: {
            placeholder: 'Catalogo',
            enabled: true
          }
        },
        {
          label: 'Proveedor',
          field: 'provider',
          filterOptions: {
            placeholder: 'Proveedor',
            enabled: true
          }
        },
        {
          label: 'Detalle',
          field: 'config'
        }
      ],
      fields: [
        { key: 'id_client', label: 'No. cliente', sortable: true, sortDirection: 'desc' },
        { key: 'client', label: 'Cliente', sortable: true, sortDirection: 'desc' },
        { key: 'statusName', label: 'Tipo', sortable: true, sortDirection: 'desc' },
        { key: 'cantidad', label: 'Cantidad', sortable: true, sortDirection: 'desc' },
        { key: 'date', label: 'Fecha', sortable: true, sortDirection: 'desc' }
      ],
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser'
    })
  },
  methods: {
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      // this.loadItems()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      // this.loadItems()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      // this.loadItems()
    },
    onColumnFilter (params) {
      this.updateParams(params)
      // this.loadItems()
    },
    async loadItems (marca) {
      try {
        console.log('Marca LoadsItems', marca.marca)
        this.jsondata = []
        const params = {
          status: 1,
          enterprise: this.user.enterprise_id
        }
        const response = await axiosAdelaService.post('/getInventaryForProvider', params)
        console.log('getInventaryForProvider response.data.rows', response.data.rows)
        console.log('', response)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          if (this.totalRecords > 0) {
            // this.jsondata = response.data.rows
            response.data.rows.forEach(el => {
              console.log('response.data.rows', el)
              const items = []
              el.items.forEach(it => {
                console.log('algodones', it)
                items.push({
                  barcode: it.barcode,
                  product: it.producto,
                  amount: it.diferencia,
                  catalogo: it.catalogo,
                  provider: it.provider,
                  id_provider: it.id_provider,
                  order_id: it.id_order
                })
              })
              console.log('Items: ', items)
              this.forExcel.push(...items)
              this.jsondata.push({
                provider: el.provider,
                id_provider: el.id_provider,
                items: items
              })
            })
          } else {
            this.$toastedPush({
              message: `No existen mas registros para ${marca.marca}.`,
              type: 'error'
            })
            // this.$router.push({ name: 'stocktaking' })
          }
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudo obtener el inventario general, por favor intentelo más tarde.')
      }
    },
    async ShowDetail (...args) {
      this.detailStocktaking = args
      await this.detalleInventario(args[0])
      this.$modal.show('DetalleInventario')
    },
    async detalleInventario (args) {
      try {
        this.itemsInventarioDetail = []
        const items = {
          function: 'detalleInventarioPorOrder_id',
          order_id: args.order_id
        }
        const params = await this.toFormData(items)
        const response = await axiosAdelaService.post('', params)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          if (this.totalRecords > 0) {
            console.log('response.data.rows', response.data.rows)
            response.data.rows.forEach(el => {
              this.itemsInventarioDetail.push({
                client: el.client,
                statusName: el.statusName,
                cantidad: el.statusName === 'compra' ? el.entrada : el.salida,
                date: el.date,
                id_client: el.id_client
              })
            })
          } else {
            this.$toastedPush({
              message: 'No existen mas registros para este inventario',
              type: 'error'
            })
            this.$router.push({ name: 'stocktaking' })
          }
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudo obtener el inventario, por favor intentelo más tarde.')
      }
    }
  },
  async mounted () {
    await this.loadItems(this.$route.params)
    this.nameMarca = this.$route.params.marca
    this.id_provider = this.$route.params.id_provider === undefined ? this.$route.params.id_provider : 0
  }
}
</script>

<style>
.btnGenerateBuy {
  display: inline-block;
}
.table {
  margin: auto;
  border-collapse: collapse;
  border: 1px solid #fff; /*for older IE*/
  border-style: hidden;
  font-size: 10px;
}
.table caption {
  background-color: #f79646;
  color: #fff;
  font-size: x-large;
  font-weight: bold;
  letter-spacing: .1em;
}
.table thead th {
  padding: 2px;
  background-color: #fde9d9;
  font-size: large;
}
.table thead th#thDay {
  width: 10%;
}
.table thead th#thRegular, .table thead th#thOvertime, .table thead th#thTotal {
  width: 10%;
}
.table th, .table td {
  padding: 1px;
  border-width: 1px;
  border-style: solid;
  border-color: #f79646 #ccc;
}
.table td {
  text-align: center;
}
.table tbody th {
  text-align: center;
  font-weight: normal;
}
.table tfoot {
  font-weight: bold;
  font-size: large;
  background-color: #687886;
  color: #fff;
}
.table tr.even {
  background-color: #fde9d9;
}
</style>
